import type { Team } from '@airmail/engine';
import { locale, t } from '@/i18n';

export function playerList(team: Team): string {
  return team.players.map((p) => p.displayName ?? `${p.firstName ? p.firstName[0] + '. ' : ''}${p.lastName}`).join(' · ');
}

/** „Vorname Nachname“, Ersatzspieler mit Zusatz „(Ersatz)“ — übersetzt, das stand sonst deutsch auf dem italienischen Etikett */
export function fullName(p: { firstName: string; lastName: string; substitute?: boolean }): string {
  const name = `${p.firstName} ${p.lastName}`.trim();
  return p.substitute ? t('{name} (Ersatz)', { name }) : name;
}

export function fmtTime(ms: number | undefined): string {
  if (ms === undefined) return '–';
  return new Date(ms).toLocaleTimeString(locale(), { hour: '2-digit', minute: '2-digit' });
}

export function fmtDate(iso: string | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString(locale(), { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' });
}

/**
 * Wert eines `<input type="date">` („2026-10-03") ausgeschrieben in der
 * Sprache der App — als Hinweis unter dem Feld. Das Feld selbst zeigt das
 * Datum im Format des Browsers (ein englisches Handy: „10/03/2026"), was in
 * einer italienischen Oberfläche leicht als 10. März gelesen wird.
 * Ortszeit, nicht UTC: sonst stünde westlich von Greenwich der Vortag da.
 */
export function fmtDateInput(v: string | undefined): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v ?? '');
  if (!m) return '';
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString(locale(), { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
}

export function fmtMinutes(min: number): string {
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  return h > 0 ? t('{h} h {m} min', { h, m: m.toString().padStart(2, '0') }) : t('{m} min', { m });
}

export function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}
